import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.jq = bracketIndenting({
	line: "#",
})
